export function createDefaultConfigurationApplied(data) {
    return {
        name: 'DefaultConfigurationApplied',
        environments: ['device'],
        data: data
    };
}
//# sourceMappingURL=createDefaultConfigurationApplied.js.map